var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 59,
    viewBox: "0 0 199 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 59,
    rx: 29.5,
    fill: "#F5F5F5",
    fillOpacity: 0.15,
    style: {
      mixBlendMode: "luminosity"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30,
    r: 24,
    fill: "#151515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.07 30.062a.47.47 0 0 1-.473.466h-8.692c.223 2.181 1.835 4.177 4.117 4.177 1.56 0 2.713-.599 3.579-1.862.092-.134.223-.227.38-.227.25 0 .433.187.433.44 0 .093-.026.16-.066.226-.878 1.543-2.622 2.301-4.326 2.301-2.924 0-5.022-2.66-5.022-5.494 0-2.847 2.085-5.495 5.022-5.495 2.923 0 5.034 2.634 5.047 5.468zm-.932-.412c-.183-2.182-1.835-4.178-4.117-4.178-2.28 0-3.893 1.996-4.116 4.178h8.233zm11.486-4.843c.249 0 .432.226.432.44a.423.423 0 0 1-.432.438H85.29v9.3a.44.44 0 0 1-.433.438c-.249 0-.432-.226-.432-.439v-9.299h-2.242a.423.423 0 0 1-.433-.439.44.44 0 0 1 .433-.439h2.242v-3.392c0-.226.17-.44.393-.466a.43.43 0 0 1 .485.439v3.42h2.32zm14.238 4.497v5.627a.448.448 0 0 1-.432.44.424.424 0 0 1-.433-.44v-5.627c0-1.903-1.062-3.792-3.147-3.792-2.674 0-3.828 2.368-3.67 4.803 0 .066.025.346.025.386v4.217c0 .226-.17.439-.393.466a.43.43 0 0 1-.485-.44V16.44A.44.44 0 0 1 93.76 16c.249 0 .432.226.432.439v10.457c.748-1.357 2.085-2.275 3.645-2.275 2.57 0 4.025 2.275 4.025 4.683zm15.616.758a.47.47 0 0 1-.472.466h-8.693c.223 2.181 1.836 4.177 4.117 4.177 1.56 0 2.714-.599 3.579-1.862.092-.134.223-.227.38-.227.25 0 .433.187.433.44a.42.42 0 0 1-.065.226c-.879 1.543-2.623 2.301-4.327 2.301-2.924 0-5.022-2.66-5.022-5.494 0-2.847 2.085-5.495 5.022-5.495 2.911 0 5.021 2.634 5.048 5.468zm-.944-.412c-.184-2.182-1.836-4.178-4.117-4.178-2.268 0-3.894 1.996-4.117 4.178h8.234zm11.616-4.43c0 .279-.157.439-.406.478-2.557.386-3.711 2.502-3.711 4.963v4.217c0 .226-.17.44-.393.466a.43.43 0 0 1-.485-.44v-9.618c0-.226.17-.439.393-.466a.43.43 0 0 1 .485.44v1.955c.721-1.237 2.15-2.408 3.645-2.408.223 0 .472.16.472.413zm14.304 4.842a.47.47 0 0 1-.472.466h-8.692c.222 2.181 1.835 4.177 4.116 4.177 1.561 0 2.714-.599 3.58-1.862.092-.134.223-.227.38-.227.249 0 .433.187.433.44a.42.42 0 0 1-.066.226c-.878 1.543-2.622 2.301-4.327 2.301-2.923 0-5.021-2.66-5.021-5.494 0-2.847 2.085-5.495 5.021-5.495 2.924 0 5.035 2.634 5.048 5.468zm-.931-.412c-.183-2.182-1.835-4.178-4.117-4.178-2.281 0-3.894 1.996-4.116 4.178h8.233zm14.986-4.324v9.658a.448.448 0 0 1-.432.44.423.423 0 0 1-.433-.44V33.15c-.721 1.45-1.993 2.5-3.619 2.5-2.583 0-4.012-2.274-4.012-4.682v-5.654a.44.44 0 0 1 .433-.44c.249 0 .433.227.433.44v5.654c0 1.902 1.062 3.791 3.146 3.791 2.924 0 3.619-2.78 3.619-5.853v-3.606c0-.266.275-.532.59-.412.157.08.275.253.275.439zm22.014 3.938v5.654a.448.448 0 0 1-.433.439.424.424 0 0 1-.433-.439v-5.654c0-1.903-1.062-3.765-3.146-3.765-2.622 0-3.619 2.847-3.619 5.055v4.364a.448.448 0 0 1-.433.439.423.423 0 0 1-.432-.439v-5.654c0-1.903-1.062-3.765-3.147-3.765-2.648 0-3.737 2.115-3.645 4.936 0 .066.026.186 0 .226v4.244c0 .226-.17.439-.393.465a.43.43 0 0 1-.485-.439v-9.645c0-.226.17-.439.393-.466a.43.43 0 0 1 .485.44v1.61c.748-1.358 2.085-2.25 3.645-2.25 1.77 0 3.147 1.145 3.711 2.808.721-1.65 2.124-2.807 3.92-2.807 2.556 0 4.012 2.248 4.012 4.643z",
    fill: "#E9F0FF",
    stroke: "#E9F0FF",
    strokeWidth: 0.245
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.995 35.552 40 30.153l-9.005-4.145L22 30.153l8.995 5.4z",
    fill: "#E9F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M30.995 26.007V15L22 30.153l8.995 5.399v-9.545z",
    fill: "#E9F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m30.992 35.552 9.006-5.4L30.992 15v20.552z",
    fill: "#E9F0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M30.995 37.277 22 31.889l8.995 12.865v-7.477z",
    fill: "#E9F0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m39.998 31.889-9.006 5.388v7.477l9.006-12.865z",
    fill: "#E9F0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -81.549,
    y: -81.549,
    width: 362.097,
    height: 222.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 40.774
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_101:3696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_101:3696",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.c26117687ee8c7015a024db0c80f8f80.svg";
export { ForwardRef as ReactComponent };